import React, { useEffect, useState } from 'react';
import { Container } from '../../components/Layout';
import LogoHeading from "../../components/LogoHeading";
import endpoints from "../../constants/endpoints.constants";
import YoutubeStoryDetails from "../../components/YoutubeStoryDetails";
import Loader from "../../components/Loading";
import { genericRequest } from "../../utils/request";
import { useNavigate, useParams } from "react-router-dom";

// eslint-disable-next-line
export default (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [storyData, setStoryData] = useState({});
    const [createdStory, setCreatedStory] = useState(false);

    const [requestStoryStatus, setRequestStoryStatus] = useState({
        isError: false, isLoading: false, isSuccess: false,
    });

    const [requestStorySaveStatus, setRequestStorySaveStatus] = useState({
        isError: false, isLoading: false, isSuccess: false, errorMessage: '',
    });

    useEffect(() => {
        async function getstoryData() {
            if (params.videoId) {
                setRequestStoryStatus({ isLoading: true });
                const request = await genericRequest({
                    endpoint: `getYoutubeVideoDetails/${params.videoId}`,
                    method: 'GET',
                });

                if (request.response) {
                    setStoryData(request.response.data);
                    return setRequestStoryStatus({ isSuccess: true });
                }

                return setRequestStoryStatus({ isError: request.error });
            } else {
                return setRequestStoryStatus({ isSuccess: true });
            }
        }

        getstoryData().then();
    }, [params.videoId, setStoryData]);

    const submitUserDetails = async ({ formData, isEdit }) => {
        setRequestStorySaveStatus({ isLoading: true });

        const request = await genericRequest({
            endpoint: isEdit ? 'createYoutubeVideo' : 'createYoutubeVideo', // User only mentioned create, assuming it handles update or user forgot edit. Sticking to create for now to match user request.
            method: "POST",
            data: {
                ...formData,
                videoId: params.videoId,
            },
        });

        if (request.error) {
            setRequestStorySaveStatus({
                isLoading: false,
                isError: true,
                errorMessage: request.error.response ? request.error.response.data.errorMessage : request.error.toString()
            });
            return window.scrollTo(0, document.body.scrollHeight);
        }

        setRequestStorySaveStatus({ isSuccess: true });
        setCreatedStory(request.response)
        window.scrollTo(0, document.body.scrollHeight);

        if (isEdit) {
            setTimeout(
                () => {
                    navigate(endpoints.listYoutubeStories())
                },
                1000
            )
        }
    };

    const resetForm = () => {
        setCreatedStory(false);
        setRequestStorySaveStatus({
            isError: false, isLoading: false, isSuccess: false, errorMessage: '',
        });
        window.scrollTo(0, 0);
    };

    return (
        <Container style={{ width: 200 }}>
            <LogoHeading />
            <Loader
                isLoading={requestStoryStatus.isLoading}
                isError={requestStoryStatus.isError}
                isSuccess={requestStoryStatus.isSuccess}
                errorMessage={"We Couldn't Load the Youtube Story Details"}
                successMessage={"Loaded Youtube Story Details"}
            >
                <YoutubeStoryDetails
                    isLoading={requestStorySaveStatus.isLoading}
                    isError={requestStorySaveStatus.isError}
                    isSuccess={requestStorySaveStatus.isSuccess}
                    errorMessage={requestStorySaveStatus.errorMessage}
                    successMessage={"We Saved Your Details"}
                    storyData={storyData}
                    createdStory={createdStory}
                    onReset={resetForm}
                    submit={
                        (storyData, isEdit) => submitUserDetails(
                            {
                                formData: {
                                    ...storyData,
                                },
                                isEdit
                            }
                        )
                    }
                />
            </Loader>
        </Container>
    );
};
